import { UPDATE_HEADER_DATA, CANDIDATE_PROFILE } from '../mutations';

const initialState = {
  profile: null,
  headerData: {}
};

export default function candidateReducer(state = initialState, action) {
  switch (action.type) {
    case CANDIDATE_PROFILE:
      return { ...state, profile: action.payload };
    case UPDATE_HEADER_DATA:
      return { ...state, headerData: { ...state.headerData, ...action.payload } };
    default:
      return state;
  }
}
